import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// ---Third-party imports
import React, { useState, useRef } from 'react';
import clsx from 'clsx';
// ---Framework imports
import { Sel } from 'uix/registries';
import { useSelector } from 'uix/hooks';
// ---Local imports
import S from './nativeComps.css';
import { useEffect } from 'react';
export const Form = ({ children })=>{
    return /*#__PURE__*/ _jsx("div", {
        className: clsx('form', S.form),
        children: children
    });
};
const FormItem = ({ children })=>{
    return /*#__PURE__*/ _jsx("li", {
        className: clsx('formItem', S.formItem),
        children: children
    });
};
const FormGroup = ({ title, children })=>{
    if (title) {
        return /*#__PURE__*/ _jsxs("div", {
            className: clsx('formGroup', S.formGroup),
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: clsx('title', S.title),
                    children: title
                }),
                /*#__PURE__*/ _jsx("ul", {
                    children: children
                })
            ]
        });
    } else {
        return /*#__PURE__*/ _jsx("ul", {
            className: clsx('formGroup', S.formGroup),
            children: children
        });
    }
};
const Checkbox = ({ label, className, key = '1', checked = false, onChange, onClick, ...props })=>{
    let [active, setActive] = useState(false);
    useEffect(()=>{
        checked && setActive(checked);
    }, [
        checked
    ]);
    let toggleActive = (e)=>{
        onChange && onChange(e);
        setActive(e.target.checked);
    };
    return /*#__PURE__*/ _jsx("a", {
        className: clsx(S.checkbox, className, 'checkbox'),
        ...props,
        children: /*#__PURE__*/ _jsxs("label", {
            children: [
                /*#__PURE__*/ _jsx("span", {
                    className: clsx('checker', S.checker, active && S.active, 'active'),
                    children: " "
                }),
                /*#__PURE__*/ _jsx("input", {
                    onChange: (e)=>toggleActive(e),
                    type: "checkbox"
                }),
                /*#__PURE__*/ _jsx("span", {
                    className: clsx('label', S.label),
                    children: label
                })
            ]
        })
    }, key);
};
Form.Checkbox = ({ ...props })=>/*#__PURE__*/ _jsx(FormItem, {
        children: /*#__PURE__*/ _jsx(Checkbox, {
            ...props
        })
    });
Form.Group = FormGroup;
export const Dropdown = ({ className, disabled, simple, options, onSetValue, onChange, selection, selected, placeholder, experimental })=>{
    let i18n = useSelector(Sel.i18n);
    let ref = useRef();
    let [focused, setFocused] = useState(false);
    let [optText, setOptText] = useState(false);
    let [open, setOpen] = useState(false);
    const onFocus = ()=>setFocused(true);
    const onBlur = ()=>setFocused(false);
    const onChanged = (e)=>{
        !onChange ? onSetValue && onSetValue(e.target.value) : onChange;
        ref.current && ref.current.blur();
    };
    const onOpen = (e)=>{
        e.stopPropagation();
        setOpen(!open);
    };
    const handleOption = (e, opt)=>{
        onChanged(e);
        setOptText(opt.text);
    };
    let minWidth = 120;
    if (experimental) {
        return /*#__PURE__*/ _jsx(Button, {
            className: clsx(S.experimentalDropdown, S.chevron),
            style: {
                minWidth: `${minWidth}px`
            },
            basic: true,
            content: optText || placeholder,
            onClick: (e)=>onOpen(e),
            children: open && /*#__PURE__*/ _jsx("div", {
                className: S.select,
                children: options && options.map((opt, i)=>{
                    return /*#__PURE__*/ _jsx("option", {
                        onClick: (e)=>handleOption(e, opt),
                        value: opt.value || opt,
                        children: opt.text || opt ? opt.text || i18n.get(opt) : 'Missing text'
                    }, i);
                })
            })
        });
    } else {
        return /*#__PURE__*/ _jsx("span", {
            className: clsx('dropdown', className, S.dropdown, !simple && S.chevron, focused && S.focused, selection && S.selection),
            children: /*#__PURE__*/ _jsxs("select", {
                ref: ref,
                onBlur: onBlur,
                onFocus: onFocus,
                defaultValue: selected || placeholder && 'placeholder' || null,
                disabled: disabled,
                onChange: (e)=>onChanged(e),
                children: [
                    placeholder && /*#__PURE__*/ _jsx("option", {
                        value: "placeholder",
                        disabled: true,
                        children: placeholder
                    }),
                    options && options.map((opt, i)=>{
                        return /*#__PURE__*/ _jsx("option", {
                            value: opt.value || opt,
                            children: opt.text || opt ? opt.text || i18n.get(opt) : 'Missing text'
                        }, i);
                    })
                ]
            })
        });
    }
};
export const Button = ({ active, basic, className, children, content, onClick, ...props })=>{
    return /*#__PURE__*/ _jsxs("button", {
        className: clsx(className, S.button, active && S.active, basic && S.basic),
        onClick: onClick,
        ...props,
        children: [
            children,
            content
        ]
    });
};
